import { useEffect, useState } from 'react';
import List from '../components/list/List';
import { s } from './Mypage.styles';
import { FilterType, Region } from '../search/FilterData';
import InterestSerivce from '../../service/Interest';
import AddInterestItemModal from '../components/modal/AddInterestItem';
type SortOption = { value: string; label: string };

const RecentItem = () => {
  const [filters, setFilters] = useState<FilterType>({
    type: '',
    regionOrCourt: 'r',
    region: [] as Region[],
    court: '',
    itemStatus: [],
    multiItemStatus: [],
    appraisalPrice: { min: '', max: '' },
    minPrice: { min: '', max: '' },
    saleDate: { start: '', end: '' },
    approvalDate: { start: '', end: '' },
    buildingArea: { min: '', max: '' },
    landArea: { min: '', max: '' },
    bidno: '',
    progressStatus: '진행',
    useArea: [],
    multiUseArea: [],
    specialConditionViewOption: 'o',
    specialItemCondition: [],
    multiSpecialItemCondition: [],
    holdingCompany: [],
    multiHoldingCompany: [],
  });
  const [loading, setLoading] = useState(false);
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [data, setData] = useState([]);
  const [sort, setSort] = useState<SortOption>({
    value: 'DA',
    label: '매각기일 빠른순',
  });
  const [showLikeModal, setShowLikeModal] = useState<boolean>(false);
  const [mode, setMode] = useState<string>('add');
  const [selectedIdx, setSelectedIdx] = useState<number>(0);
  const [selectedItem, setSelectedItem] = useState({
    iidx: 0,
    group: '',
    group_idx: 0,
    level: 0,
    memo: '',
  });
  const [activeItem, setActiveItem] = useState<number | null>(null);

  const getList = async (
    offset: number,
    sort: {
      value: string;
      label: string;
    },
  ) => {
    setLoading(true);
    try {
      const res = await InterestSerivce.list(
        'N',
        filters.type,
        filters.regionOrCourt,
        filters.court,
        filters.region
          .map((item) => `${item.sido} ${item.sigungu} ${item.emd}`)
          .join(','),
        '',
        '',
        filters.progressStatus,
        filters.itemStatus.join(',') === ''
          ? filters.multiItemStatus.join(',')
          : filters.itemStatus.join(','),
        filters.group === '' ? -1 : Number(filters.group),
        filters.level === '' ? 0 : Number(filters.level),
        sort.value,
        limit,
        offset,
      );
      setData(res.data.list);
      setTotal(Number(res.data.countInfo.total));
      setLoading(false);
    } catch (error) {
      console.error('getList 함수에서 에러 발생:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getList(0, sort);
  }, []);

  useEffect(() => {
    getList(offset, sort);
  }, [offset]);

  useEffect(() => {
    if (data.length === 0) return;
    setOffset(0);
    getList(0, sort);
  }, [sort]);

  return (
    <s.Container>
      <s.RecentCommentBox>
        <span>최근 본 물건을 확인 할 수 있습니다.</span>
        <span style={{ color: 'rgba(55, 56, 60, 0.61)' }}>
          (최근 14일 이내)
        </span>
      </s.RecentCommentBox>
      <List
        data={data}
        totalCount={total}
        sort={sort}
        setSort={setSort}
        offset={offset}
        setOffset={setOffset}
        filters={filters}
        limit={limit}
        loading={loading}
        page="recent"
        setSelectedIdx={setSelectedIdx}
        setShowLikeModal={setShowLikeModal}
        setMode={setMode}
        setSelectedItem={setSelectedItem}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        getList={getList}
      />
      {showLikeModal && (
        <AddInterestItemModal
          setShowLikeModal={setShowLikeModal}
          selectedIdx={selectedIdx}
          mode={mode}
          selectedItem={selectedItem}
          getList={getList}
          offset={offset}
          sort={sort}
          filters={filters}
          setActiveItem={setActiveItem}
        />
      )}
    </s.Container>
  );
};
export default RecentItem;
